/**
 * @file: index.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import dark from './dark';
import light from './light';

export default { dark, light };
